<template>
  <div>
    {{msg}}
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      msg: 'index page'
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/index.vue